<!-- pixel precision is intentional here, be careful when adjusting -->
<div
	class="flex gap-1 border-grey-veryLight items-center border-[1px] px-3 py-0.5 rounded-[2px] bg-white"
>
	<div
		class="flex-auto text-grey-dark text-xs leading-5 font-semibold mb-[2px]"
		[testHook]="testHooks.StatusLabelDiv"
	>
		{{ matterStatusLabels[status] }}
	</div>
	<div
		class="rounded w-[10px] h-[10px] {{ matterStatusColorClass[status] }}"
	></div>
</div>
